import React from 'react';
import './LoupeEffect.css';

export function LoupeEffect({
  src,
  x = 0,
  y = 0,
  width = 0,
  height = 0,
  zoom = 2.5,
  loupeSize = 150,
}) {
  const half = loupeSize / 2;

  // Limitar el lente dentro de los bordes del contenedor
  const maxX = Math.max(0, width - loupeSize);
  const maxY = Math.max(0, height - loupeSize);
  const left = Math.max(0, Math.min(x - half, maxX));
  const top = Math.max(0, Math.min(y - half, maxY));

  // Posición del fondo para centrar el punto del cursor en la lupa
  const bgX = x * zoom - half;
  const bgY = y * zoom - half;

  const style = {
    position: 'absolute',
    left: `${left}px`,
    top: `${top}px`,
    width: `${loupeSize}px`,
    height: `${loupeSize}px`,
    backgroundImage: src ? `url("${src}")` : undefined,
    backgroundSize:
      width && height ? `${width * zoom}px ${height * zoom}px` : `${zoom * 100}%`,
    backgroundPosition: `-${bgX}px -${bgY}px`,
    backgroundRepeat: 'no-repeat',
    backgroundColor: '#fff',
    pointerEvents: 'none',
  };

  return <div className="loupe visible" style={style} />;
}

export default LoupeEffect;